import * as yup from 'yup';
import { validateSchema } from "../utils/validationUtils";

export const reportSchema = yup.object().shape({
    selectedStatus: yup
        .string()
        .required('Trạng thái là bắt buộc')
        .test('trim', 'Trạng thái là bắt buộc', value => value && value.trim().length > 0),
    responseContent: yup
    .string()
    .nullable()
    .notRequired()
    .transform((v) => (v === '' ? null : v)),
    // expectedResponseDate: yup
    //     .date()
    //     .nullable()
    //     .when('selectedStatus', {
    //         is: (status) => status !== 'Đã giải quyết' && status !== 'Đóng',
    //         then: (schema) => schema
    //             .required('Thời gian phản hồi dự kiến là bắt buộc')
    //             .test(
    //                 'is-future-date',
    //                 'Thời gian phản hồi dự kiến phải sau ngày hiện tại',
    //                 (value) => {
    //                     if (!value) return true;
    //                     return value > new Date();
    //                 }
    //             ),
    //         otherwise: (schema) => schema.notRequired()
    //     }),
    // expectedCompletionDate: yup
    //     .date()
    //     .nullable()
    //     .when('selectedStatus', {
    //         is: (status) => status !== 'Đã giải quyết' && status !== 'Đóng',
    //         then: (schema) => schema
    //             .required('Thời gian hoàn thành dự kiến là bắt buộc')
    //             .test(
    //                 'is-after-expected-response-date',
    //                 'Thời gian hoàn thành dự kiến phải sau thời gian phản hồi dự kiến',
    //                 function (value) {
    //                     const { expectedResponseDate } = this.parent;
    //                     if (!value || !expectedResponseDate) return true;
    //                     return value > expectedResponseDate;
    //                 }
    //             ),
    //         otherwise: (schema) => schema.notRequired()
    //     }),
});

export const createReportSchema = yup.object().shape({
    tieuDe: yup
        .string()
        .required('Tiêu đề là bắt buộc')
        .min(10, 'Tiêu đề phải có ít nhất 10 ký tự')
        .trim(),
    moTa: yup
        .string()
        .required('Mô tả là bắt buộc')
        .min(20, 'Mô tả phải có ít nhất 20 ký tự')
        .trim(),
    idLinhVucPhanAnh: yup
        .string()
        .required('Lĩnh vực phản ánh là bắt buộc'),
    mucDo: yup
        .string()
        .required('Mức độ phản ánh là bắt buộc'),
    viTri: yup
        .string()
        .required('Vị trí là bắt buộc')
        .trim(),
    khuPho: yup
        .string()
        .required('Khu phố là bắt buộc')
        .max(100, 'Khu phố không được vượt quá 100 ký tự')
        .trim(),
    tenNguoiPhanAnh: yup
        .string()
        .required('Họ và tên người phản ánh là bắt buộc')
        .min(2, 'Họ và tên phải có ít nhất 2 ký tự')
        .max(100, 'Họ và tên không được vượt quá 100 ký tự')
        .trim(),
    soDienThoaiNguoiPhanAnh: yup
        .string()
        .required('Số điện thoại là bắt buộc')
        .test('vietnamese-phone', 'Số điện thoại không hợp lệ (hỗ trợ 10 chữ số đầu 03, 05, 07, 08, 09 hoặc định dạng +84)', function(value) {
            if (!value || value.trim() === '') return false;
            return /^(?:0|\+84|84)(3|5|7|8|9)\d{8}$/.test(value.trim());
        })
        .trim(),
    files: yup
        .array()
        .min(1, 'Phải đính kèm ít nhất một ảnh hoặc video')
        .max(5, 'Chỉ được tải lên tối đa 5 file')
});

export async function validateReport(data) {
    const result = await validateSchema(reportSchema, data);
            
    return { isValid: result.valid, errors: result.errors };
}

export async function validateCreateReport(data) {
    const result = await validateSchema(createReportSchema, data);
    return { isValid: result.valid, errors: result.errors };
}